import { Stack } from '@mui/material';
import type { ReactNode } from 'react';
import { graphql, useFragment } from 'react-relay';

import { COMPANY_PROJECT_TYPES_ENUM } from '@woovi/roles';
import { PixPaymentWoovi } from '@woovi/ui';

import type { PaymentPixAutomatic_subscription$key } from './__generated__/PaymentPixAutomatic_subscription.graphql';
import PaymentPixAutomaticAdditionalInfo from './PaymentPixAutomaticAdditionalInfo.tsx';
import PaymentPixAutomaticCompleted from './PaymentPixAutomaticCompleted.tsx';
import PaymentPixAutomaticQRCode from './PaymentPixAutomaticQRCode.tsx';
import { PaymentPixAutomaticTitle } from './PaymentPixAutomaticTitle.tsx';
import { PaymentPixAutomaticTransactionInfo } from './PaymentPixAutomaticTransactionInfo.tsx';
import PaymentCompanyLogo from '../logo/PaymentCompanyLogo.tsx';
import { usePixAutomaticApprovedSubscription } from './subscriptions/usePixAutomaticApprovedSubscription.ts';

type PaymentPixAutomaticProps = {
  pixAutomatic: PaymentPixAutomatic_subscription$key;
};

const PaymentPixAutomatic = (props: PaymentPixAutomaticProps): ReactNode => {
  const pixAutomatic = useFragment<PaymentPixAutomatic_subscription$key>(
    graphql`
      fragment PaymentPixAutomatic_subscription on PaymentSubscription {
        id
        isActive
        value
        frequency
        comment
        isActive
        company {
          projectType
          nameFriendly
          ...PaymentCompanySupport_company
          ...PaymentCompanyLogo_company
        }
        ...PaymentPixAutomaticQRCode_subscription
        ...PaymentPixAutomaticAdditionalInfo_subscription
        ...PaymentPixAutomaticCompleted_subscription
        ...PaymentPixAutomaticTitle_subscription
        ...PaymentPixAutomaticTransactionInfo_subscription
      }
    `,
    props.pixAutomatic,
  );

  usePixAutomaticApprovedSubscription({
    input: {
      paymentSubscriptionId: pixAutomatic.id,
    },
  });

  if (pixAutomatic.isActive) {
    return <PaymentPixAutomaticCompleted pixAutomatic={pixAutomatic} />;
  }

  return (
    <Stack sx={{ gap: 2 }}>
      <PaymentCompanyLogo company={pixAutomatic.company} />
      <PaymentPixAutomaticTitle pixAutomatic={pixAutomatic} />
      <PaymentPixAutomaticQRCode pixAutomatic={pixAutomatic} />
      <PaymentPixAutomaticAdditionalInfo pixAutomatic={pixAutomatic} />
      <PaymentPixAutomaticTransactionInfo pixAutomatic={pixAutomatic} />
      <PixPaymentWoovi projectType={COMPANY_PROJECT_TYPES_ENUM.WOOVI} isTemp />
    </Stack>
  );
};

export default PaymentPixAutomatic;
